// extracted by css-extract-rspack-plugin
export default {"root":"JYvhFZ","bigger-font":"UdQ_c2","biggerFont":"UdQ_c2","before-discount":"j6QGVK","beforeDiscount":"j6QGVK"};